import { Nullable } from '../../types/common'
import { debounce } from '../../utils/debounce'
import SidebarBtn from '../sidebar/sidebar-btn'

class MobileFiltersStickyButton extends SidebarBtn {
  products: Nullable<HTMLElement>
  footer: Nullable<HTMLElement>
  lastScrollPosition: number

  constructor() {
    super()

    this.products = document.getElementById('ShopProducts')
    this.footer = document.querySelector<HTMLElement>('.shopify-section-footer')
  }

  connectedCallback(): void {
    super.connectedCallback()

    window.addEventListener('scroll', this.handleWindowScroll)
  }

  disconnectedCallback(): void {
    super.disconnectedCallback()

    window.removeEventListener('scroll', this.handleWindowScroll)
  }

  handleWindowScroll = (): void => {
    if (!this.lastScrollPosition) {
      this.lastScrollPosition = window.scrollY
    }

    this.updateVisibleStatus()
    this.updateExtendStatus()
  }

  updateVisibleStatus(): void {
    const footerOffsetTop = this.footer ? this.footer.offsetTop : 0

    const productsRect = this.products.getBoundingClientRect()

    const isUnderFooter = window.innerHeight + window.scrollY < footerOffsetTop
    const isUnderProductTopSide = productsRect.top < 0

    const isVisible = isUnderFooter && isUnderProductTopSide

    this.toggleAttribute('is-visible', isVisible)

    document.body.toggleAttribute('is-filters-button-fixed', isVisible)
  }

  updateExtendStatus = debounce((): void => {
    const threshold = 24
    const distance = Math.abs(window.scrollY - this.lastScrollPosition)

    if (distance > threshold) {
      const isExtended = this.lastScrollPosition > window.scrollY

      this.toggleAttribute('is-extended', isExtended)
    }

    this.lastScrollPosition = 0
  }, 50)
}

export default MobileFiltersStickyButton
